/* Fashion CITY — 최소 주문 수량 (한 주문 기준)
   ─────────────────────────────────────────────────────────
   ★★ 최소 수량은 아래 표 하나만 고치면 됩니다. ★★
      assets/fc-qty.js 도 이 표를 그대로 가져다 씁니다.
      숫자가 두 군데 있으면 한쪽만 고치는 사고가 나서 여기 한 곳으로 모았습니다.

        전 품목 12개 — 모자, 옷, 가방 모두 같습니다.
        (2026-09 변경: 예전에는 모자 24 / 옷 6 / 가방 12 였습니다)

   ── 어떻게 세는가 ──
   '한 줄' 이 아니라 '한 주문' 기준입니다.
   지금 담으려는 수량 + 이미 장바구니에 들어있는 같은 종류 수량을 더해서 봅니다.
   그래서 캐 검정 6개 담고 베이지 6개 담으면 합쳤서 12개로 인정됩니다.
   색깔마다 따로 담아야 하는 구조라서, 이렇게 안 하면 색을 나눠 살 수가 없습니다.
   ※ 같은 종류끼리만 셉니다. 모자는 모자끼리, 옷은 옷끼리, 가방은 가방끼리.

   ── 언제 막는가 ──
   장바구니 담기를 누를 때. 몇 개 모자라는지 딜 집어서 알려줍니다.

   ※ 이 파일은 fc-po-login.js / fc-po.js 보다 먼저 실행돼야 합니다.
*/
(function () {
  'use strict';

  /* 상품주소(handle) : [최소수량, 묶음이름, 부르는 말] */
  var RULES = {
    'custom-two-tone-trucker-hat-your-design': [12, 'cap',     'hat'],
    'custom-baseball-cap-your-design':         [12, 'cap',     'hat'],
    'custom-sweatshirt-your-design':           [12, 'apparel', 'piece'],
    'custom-hoodie-your-design':               [12, 'apparel', 'piece'],
    'custom-t-shirt-g5000':                    [12, 'apparel', 'piece'],
    'custom-t-shirt-c1717':                    [12, 'apparel', 'piece'],
    'custom-cotton-tote-bag-your-design':      [12, 'bag',     'bag']
  };

  /* fc-qty.js 가 수량칸 시작값으로 씁니다 */
  var byHandle = {};
  for (var h in RULES) {
    if (Object.prototype.hasOwnProperty.call(RULES, h)) byHandle[h] = RULES[h][0];
  }
  window.FC_MIN_BY_HANDLE = byHandle;

  var cfgEl = document.getElementById('fc-po-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var HANDLE = CFG.handle || '';
  var RULE = RULES[HANDLE];
  if (!RULE) {
    if (CFG.category === 'cap') RULE = [12, 'cap', 'hat'];
    else if (CFG.category === 'bag') RULE = [12, 'bag', 'bag'];
    else RULE = [12, 'apparel', 'piece'];
  }
  var NEED = RULE[0], GROUP = RULE[1], WORD = RULE[2];

  var inCart = 0;
  var lastKey = '';

  function panel() { return document.querySelector('[data-fcpo]'); }
  function pform() { return document.querySelector('form.js-product-form'); }
  function sizeBoxes() { return document.querySelectorAll('[data-fcpo-run-size]'); }

  function hereQty() {
    var b = sizeBoxes();
    if (b.length) {
      var t = 0;
      for (var i = 0; i < b.length; i++) t += (parseInt(b[i].value, 10) || 0);
      return t;
    }
    var f = pform();
    var q = f ? f.querySelector('[name="quantity"]') : null;
    var n = q ? parseInt(q.value, 10) : 0;
    return (isNaN(n) || n < 0) ? 0 : n;
  }
  function noun(n) { return n + ' ' + WORD + (n === 1 ? '' : 's'); }

  function refreshCart() {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var t = 0;
          (c.items || []).forEach(function (it) {
            var rule = RULES[String(it.handle || '')];
            if (rule && rule[1] === GROUP) t += (it.quantity || 0);
          });
          inCart = t;
          lastKey = '';
          render();
        })
        .catch(function () {});
    } catch (e) {}
  }

  function ensure() {
    var p = panel();
    if (!p) return null;
    var el = p.querySelector('[data-fcpo-min]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'fcpo-min';
      el.setAttribute('data-fcpo-min', '');
      p.appendChild(el);
    }
    var total = p.querySelector('[data-fcpo-total]');
    if (total && total.nextSibling !== el) p.insertBefore(el, total.nextSibling);
    return el;
  }

  function missingNow() { return NEED - (hereQty() + inCart); }

  function render() {
    var el = ensure();
    if (!el) return;
    var here = hereQty();
    var key = here + '|' + inCart;
    if (key === lastKey) return;
    lastKey = key;

    var missing = NEED - (here + inCart);

    if (here === 0 && inCart === 0) {
      el.className = 'fcpo-min';
      el.textContent = 'Minimum order: ' + noun(NEED) + '. You can split that across colors.';
      return;
    }
    if (missing > 0) {
      el.className = 'fcpo-min is-short';
      el.textContent = inCart > 0
        ? (noun(here) + ' here + ' + inCart + ' already in your cart = ' + (here + inCart) +
           '. Minimum is ' + NEED + ' — ' + missing + ' to go.')
        : ('Minimum order is ' + noun(NEED) + '. You have ' + here + ' — ' + missing +
           ' to go. Add more here, or add this color and pick another one next.');
      return;
    }
    el.className = 'fcpo-min is-ok';
    el.textContent = inCart > 0
      ? (noun(here) + ' here + ' + inCart + ' in your cart = ' + (here + inCart) + '. Minimum met.')
      : ('Minimum of ' + NEED + ' met.');
  }

  function shout(msg) {
    var el = ensure();
    if (!el) return;
    if (msg) { el.className = 'fcpo-min is-short'; el.textContent = msg; lastKey = 'forced'; }
    el.classList.add('is-shout');
    setTimeout(function () { el.classList.remove('is-shout'); }, 1300);
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[name="add"]')) return;
    if (!panel()) return;

    if (sizeBoxes().length && hereQty() === 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      shout('Enter how many of each size — minimum ' + noun(NEED) + ' per order.');
      return;
    }
    if (missingNow() <= 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    render();
    shout('');
  }, true);

  document.addEventListener('input', render, true);
  document.addEventListener('change', render, true);
  setInterval(render, 400);
  refreshCart();
  window.addEventListener('pageshow', refreshCart);
})();
